var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        height: "26",
        viewBox: "0 0 30 26",
        width: "30",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("g", { attrs: { fill: "#FFF", "fill-rule": "nonzero" } }, [
        _c("path", {
          attrs: {
            d: "M29.038 15.09c-1.466 0-3.76.89-4.857 2.161-1.484-1.315-4.704-2.43-7.67-3.15-1.08-1.643-1.174-2.91-1.073-3.663a.629.629 0 0 0-.19-.54.616.616 0 0 0-.547-.156c-1.935.394-2.998 2.117-3.554 3.496l-.075-.001c-2.998 0-7.321 2.452-7.321 5.478s4.323 5.478 7.32 5.478c.1 0 .21-.003.328-.008 1.082.589 2.348.95 3.28.95 1.145 0 .585-.543-.092-1.386 3.365-.65 7.779-1.963 9.594-3.571 1.097 1.272 3.39 2.16 4.857 2.16 1.983 0-1.144-1.622-1.144-3.624 0-2 3.127-3.623 1.144-3.623zM7.104 18.778a.832.832 0 0 1-.828-.836c0-.462.37-.836.828-.836.458 0 .829.374.829.836 0 .462-.37.836-.829.836zM1.723 13.784a1.216 1.216 0 1 0 0 2.432 1.216 1.216 0 0 0 0-2.432zM3.75 10.54a.81.81 0 1 0 0 1.622.81.81 0 0 0 0-1.621zM2.534 7.297a1.216 1.216 0 1 0 .001-2.432 1.216 1.216 0 0 0 0 2.432zM4.562 1.622a.81.81 0 1 0 0-1.621.81.81 0 0 0 0 1.62z",
          },
        }),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }